import { ILearningCenterCategory } from '../../../../types/contentful';

export function getCategorySlug(category?: ILearningCenterCategory) {
  return category?.fields?.name.replaceAll(/\W/g, '-').toLocaleLowerCase();
}

export const categoryColor: Record<string, string> = {
  glossary: '#FFA9C2',
  'family-safety': '#A5F3E1',
  credit: '#FFA9C2',
  resources: '#D3D3D3',
  loans: '#DFE97D',
  budgeting: '#A5F3E1',
  'case-studies': '#D698FF',
  earning: '#B2E8FF',
  investing: '#D698FF',
  saving: '#DFE97D',
  'life-moments-and-milestones': '#D698FF',
  'spotlight-stories': '#B2E8FF',
  'home-and-chores': '#B2E8FF',
  'parenting-and-family': '#FCC861',
  'fun-facts': '#DFE97D',
  'family-shield': '#A5F3E1',
  caregiving: '#D698FF',
  popular: '#E6E2DB'
};
